import { ACTION_TYPES as RESTAURANT_ACTION_TYPES } from 'src/modules/Restaurant/constants';
import get from 'lodash/get';
import { ACTION_TYPES } from './constants';

const initialState = {
    menus: [],
    activeCategoryId: null,
    isAutoUpdateDisabled: false,
    selectedMenuId: null,
    scrollToCategoryId: null
};

export default function menuReducer(state = initialState, action) {
    switch (action.type) {
        case RESTAURANT_ACTION_TYPES.RESTAURANT_INITIALIZED: {
            const regex = new RegExp(`[.{2}]`, 'g');
            return {
                ...state,
                menus: action.payload.restaurant.menus
                    .filter((menu) => menu.name.toLowerCase().includes(`[${action.payload.lang}]`)
                    || !menu.name.match(regex))
                    .map((menu) => ({
                        ...menu,
                        name: menu.name.replace(`[${action.payload.lang}]`, '')
                            .replace(`[${action.payload.lang.toUpperCase()}]`, '')
                    })),
                activeCategoryId: get(action.payload.restaurant.menus, '[0].categories[0].id')
            };
        }

        case ACTION_TYPES.SET_ACTIVE_CATEGORY: {
            const { id, isAutoUpdateDisabled, scroll } = action.payload;

            if (scroll) {
                return {
                    ...state,
                    activeCategoryId: id,
                    scrollToCategoryId: id,
                    isAutoUpdateDisabled
                };
            }

            return {
                ...state,
                activeCategoryId: id,
                isAutoUpdateDisabled
            };
        }

        case ACTION_TYPES.ENABLE_AUTO_UPDATE_ACTIVE_CATEGORY: {
            return {
                ...state,
                isAutoUpdateDisabled: false
            };
        }

        case ACTION_TYPES.ENABLE_AUTO_UPDATE_ACTIVE_MENU: {
            return {
                ...state,
                isAutoUpdateDisabled: false
            };
        }

        default: return state;
    }
}
